import { render, staticRenderFns } from "./DosyaEsasNumarasi.vue?vue&type=template&id=9565a674"
import script from "./DosyaEsasNumarasi.vue?vue&type=script&lang=ts"
export * from "./DosyaEsasNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports